/**
 * Created by Administrator on 2017/11/3.
 */
import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {StroageService} from "../service/stroage";
import {API} from "../config/api-config";
declare var alertify:any;
@Component({
  templateUrl:'./account.html'
})

export class Account implements OnInit{
  constructor(
    private router:Router,
    private HttpService:HttpService,
    private fileUpload:FileUpload,
    private stroage:StroageService
  ){}


  //初始数据
  private isCreate=true;
  private data:any=[
  ];
  private userName=this.stroage.getStroage('username');

  ngOnInit():void{
    this.getData();
  }

  //获取数据
  private getData():void{
    this.HttpService.getData(API.account)
      .then(res=>{
        this.data=res.data;
      });
  }

  //删除数据
  private deleteAccount(id:number):void{
    let _self = this;
    alertify.confirm("删除","確定要刪除嗎？",function () {
      _self.HttpService.deleteData(API.account+"/"+id).then(res=>{
        if(res.status.code==0){
          alertify.success(res.status.message);
          _self.getData();
        }else {
          alertify.error(res.status.message);
        }
      })
    },function () {

    })
  }

  private editCont(id:number){
    this.router.navigate(['/index/account',id]);
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/account/Account.componen.ts